import { createContext, PropsWithChildren, useContext } from 'react'

export interface GetAppBannerContextI extends PropsWithChildren<unknown> {
  deepLink: string | null
  bannerVisible: boolean
  isLoading: boolean
}

export const GetAppBannerContext = createContext<GetAppBannerContextI>({
  deepLink: null,
  bannerVisible: false,
  isLoading: true,
})

export const useGetAppBanner = (): GetAppBannerContextI => {
  return useContext(GetAppBannerContext)
}
